/**
 * Dashboard charts: thin wrappers over twreact-ui charts (recharts-backed),
 * coloured with design tokens so they follow the theme and dark mode.
 */
import { BarChart, DonutChart } from '@dreamtree-org/twreact-ui/charts';
import { statusVariant } from '@/components';

const TOKEN = { success: 'success', warning: 'warning', primary: 'primary', error: 'error', default: 'gray' };
export const statusColor = (status) => TOKEN[statusVariant(status)] || 'gray';

/** Monthly bars. data: [{ label, value }]; format(value) → text. */
export function TrendBars({ data = [], format = String, height = 240, title = 'Trend' }) {
  return (
    <BarChart
      title={title}
      data={data}
      index="label"
      categories={['value']}
      colors={['primary']}
      valueFormatter={format}
      height={height}
      showLegend={false}
      yAxisWidth={56}
      accessibleTable
    />
  );
}

/** Share-of-total donut. data: [{ status, count }]. */
export function StatusMix({ data = [], title = 'Breakdown' }) {
  const total = data.reduce((a, d) => a + d.count, 0);
  const rows = data.map((d) => ({ name: String(d.label || d.status).replace(/_/g, ' '), count: d.count }));
  return (
    <DonutChart
      title={title}
      description={`${total} orders in total`}
      data={rows}
      index="name"
      category="count"
      colors={data.map((d) => statusColor(d.status))}
      centerLabel={<span className="text-lg font-bold">{total}</span>}
      height={240}
      showLegend
      accessibleTable
    />
  );
}
